import { useNavigate } from '@tanstack/react-router'
import { FilterFn, PaginationState, SortingState } from '@tanstack/react-table'
import { TableComponent } from 'components/table/TableComponent'
import { WebGLContext } from 'features/partsDatabase/contexts/WebGLLayer'
import { PartsData } from 'features/partsDatabase/types/partsTableTypes'
import React, { useContext, useEffect, useState } from 'react'

import PartsTableColumns from './PartsTableColumns'

interface PartsTableProps {
  siteID: string
  isLoading: boolean
  data: PartsData[]
}

export const PartsTable: React.FC<PartsTableProps> = (props) => {
  const { siteID, isLoading, data } = props
  const navigate = useNavigate()
  const { setAssetVizRenderingMap } = useContext(WebGLContext)

  const defaultColumns = PartsTableColumns(siteID)
  const columns = [...defaultColumns]
  const [sorting, setSorting] = React.useState<SortingState>([
    { id: 'lastUpdated', desc: true },
  ])

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 24,
  })

  useEffect(() => {
    setAssetVizRenderingMap(new Map())
  }, [pagination, setAssetVizRenderingMap])

  const handleRowClick = (row: PartsData, event: React.MouseEvent) => {
    if (event.metaKey || event.ctrlKey) {
      const url = `/assets/${siteID}/${row.id}?view=history`
      window.open(url, '_blank')
      return
    }
    event.preventDefault()
    navigate({
      to: '/assets/$siteID/$unitID',
      from: '/parts/$siteID',
      params: { siteID, unitID: row.id },
      search: { view: 'history' },
    })
  }

  const globalFilterFn: FilterFn<PartsData> = (row, _, filterValue) => {
    return row.original.componentName
      ?.toLowerCase()
      .includes(
        typeof filterValue === 'string'
          ? filterValue.toLowerCase()
          : filterValue
      )
  }

  return (
    <TableComponent
      isLoadingData={isLoading}
      data={data}
      columns={columns}
      footerName={
        data.length === 0 ? 'No parts' : data.length === 1 ? 'Part' : 'Parts'
      }
      sorting={sorting}
      setSorting={setSorting}
      pagination={pagination}
      setPagination={setPagination}
      onRowClick={(row, event) => {
        handleRowClick(row.original, event)
      }}
      globalFilterFn={globalFilterFn}
    />
  )
}
